import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3413eb18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "movies" }
const _hoisted_2 = { class: "globals" }
const _hoisted_3 = { class: "sp" }
const _hoisted_4 = { class: "categories" }
const _hoisted_5 = { class: "sp" }
const _hoisted_6 = { class: "topics" }
const _hoisted_7 = ["href"]

import i18, { State } from '@/store/i18';
import * as links from '@/views/links';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const store = useStore()
const categories = computed(() => store.state.moviesConfig.categories)
const topics = computed(() => store.state.moviesConfig.topics)

const data = computed<State>(() => store.state[i18.name])
const lang = computed<any>(() => data.value.texts[data.value.lang.list[data.value.lang.now]].movieMenu)

const globals = [
    { key: 'home', icon: 'i-home', path: '/' },
    { key: 'hot', icon: 'i-hot', path: '/content/hot/index.html' },
    { key: 'new_add', icon: 'i-zuixinfabu', path: '/content/publish/index.html' },
    { key: 'new_update', icon: 'i-new', path: '/content/update/index.html' },
    { key: 'sunday', icon: 'i-a-ziyuan3', path: '/content/category/id/205/index.html' },
    { key: 'all', icon: 'i-all', path: '/content/index.html' },
]

const current = computed(() => route.path)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(globals, (item, i) => {
        return _createVNode(_component_router_link, {
          class: _normalizeClass(["navigator", { on: _unref(current) == item.path }]),
          to: item.path
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(["icon", item.icon])
            }, null, 2),
            _createElementVNode("span", null, _toDisplayString(_unref(lang)[item.key]), 1)
          ]),
          _: 2
        }, 1032, ["class", "to"])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(lang).category), 1),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (item, i) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          class: _normalizeClass(["navigator", { on: _unref(current) == _unref(links).category(item.id) }]),
          to: _unref(links).category(item.id)
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(["icon", item.icon])
            }, null, 2),
            _createElementVNode("span", null, _toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["class", "to"]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(lang).special_topic), 1),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(topics), (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (item.islink == 1)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: item.linkurl,
                target: "_blank"
              }, _toDisplayString(item.title), 9, _hoisted_7))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: _normalizeClass({ on: _unref(current) == _unref(links).topic(item.id) }),
                to: _unref(links).topic(item.id)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1032, ["class", "to"]))
        ], 64))
      }), 256))
    ])
  ]))
}
}

})